import React, { Component } from 'react'

export default class Blank_Plan extends Component {
  render() {
    return (
      <div></div>
    )
  }
}
